/**
 * @file 删除通知
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1KJvE-27eDHJuWSjDINRLXlubG8qBZaio3oF1Ht5kX4Q/edit#}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IDeleteNoticeOutput {
    status: number;
}

export interface IDeleteNoticeInput {
    notice_id: number;
}

export const deleteNotice = (data: IDeleteNoticeInput): Promise<IDeleteNoticeOutput> => {
    return fetchData(Api.CLASS_DELETE_NOTICE, data).then((res: IResponse<IDeleteNoticeOutput>) => {
        return res.data as IDeleteNoticeOutput;
    });
};
